import { visitorMessages } from 'src/features/visitor/utils/messages';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuLabel,
    DropdownMenuTrigger,
} from 'src/registry/ui/DropdownMenu';
import { Button } from 'src/registry/ui/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';
import { cn } from 'src/utils/shadcn';
import { TranslationsWithId } from 'src/types';

type CellStayPeriodZonesProps = {
    zonesData: TranslationsWithId[];
    visitorCategory?: string;
    className?: string;
};

const CellStayPeriodZones = ({ zonesData, visitorCategory, className }: CellStayPeriodZonesProps) => {
    const { formatMessage, locale } = useIntl();

    const zonesLength = zonesData?.length;
    const zoneNames = zonesData.map((z) => z.translations?.find((t) => t.language === locale)?.name ?? '-').join(', ');

    const zones = zonesLength > 1 ? `${formatMessage(visitorMessages.multipleZones)}-${zonesLength}` : zoneNames;

    return (
        <>
            {zonesLength > 1 ? (
                <div className="flex flex-col gap-0 whitespace-nowrap">
                    <span className="flex flex-row items-center whitespace-nowrap">
                        <span
                            className={cn('font-medium whitespace-nowrap', className)}
                        >{`${formatMessage(visitorMessages.multipleZones)}-${zonesLength}`}</span>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" className="size-8 cursor-pointer p-0">
                                    <FontAwesomeIcon icon={faEllipsis} />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="center" className="w-full min-w-[200px]">
                                <DropdownMenuLabel className="text-xs font-medium text-gray-600">
                                    {formatMessage(visitorMessages.zones)}
                                </DropdownMenuLabel>
                                <DropdownMenuGroup>
                                    {zonesData?.map((zone) => {
                                        return (
                                            <span
                                                key={zone.id}
                                                className="relative flex items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors"
                                            >
                                                {zone?.translations.find((t) => t.language === locale)?.name ?? '-'}
                                            </span>
                                        );
                                    })}
                                </DropdownMenuGroup>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </span>
                    <span className="-mt-px">{visitorCategory}</span>
                </div>
            ) : (
                <span className="flex flex-col">
                    <span className={cn('font-medium whitespace-nowrap', className)}>{zones}</span>
                    <span>{visitorCategory}</span>
                </span>
            )}
        </>
    );
};

export default CellStayPeriodZones;
